import { axios } from '@Root/API'

export const putIncludeInHesa = payload => {
  return axios.put(`student-engagement/include-in-hesa`, payload)
}
